// Mock data for Fernando Tech website

export const heroSlides = [
  {
    id: 1,
    title: "Suporte de TI para Empresas",
    subtitle: "Suporte técnico empresarial completo com help desk TI e atendimento ágil para seu negócio",
    cta: "Ver Serviços de TI",
    link: "#servicos"
  },
  {
    id: 2,
    title: "Terceirização de TI",
    subtitle: "TI terceirizada com gestão completa de infraestrutura e consultoria de TI para empresas",
    cta: "Conhecer TI Terceirizada",
    link: "#servicos"
  },
  {
    id: 4,
    title: "Criação de Sites com IA",
    subtitle: "Sites modernos e profissionais desenvolvidos com Inteligência Artificial",
    cta: "Quero Meu Site",
    link: "/sites"
  },
  {
    id: 5,
    title: "Suporte Remoto de TI",
    subtitle: "Help desk TI instantâneo - Resolvemos problemas sem você sair da empresa",
    cta: "Obter Suporte Agora",
    link: "#suporte-remoto"
  }
];

export const partners = [
  { id: 1, name: "Bling ERP", logo: "./bling-logo.png" },
  { id: 2, name: "Daten", logo: "./logo-daten.jpg" },
  { id: 3, name: "Shoficina", logo: "./shoficina-logo.png" },
  { id: 4, name: "Motor OK", logo: "./motorok-logo.png" }
];

export const services = [
  {
    id: 1,
    title: "Manutenção Preventiva",
    description: "Ação planejada e sistemática de revisão, controle e monitoramento dos equipamentos.",
    icon: "Settings",
    image: "https://images.unsplash.com/photo-1560165143-fa7e2d9e594c?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"
  },
  {
    id: 2,
    title: "Suporte em TI",
    description: "Serviços prestados com o objetivo de fornecer assistência a uma infraestrutura tecnológica.",
    icon: "Headphones",
    image: "https://images.pexels.com/photos/3825580/pexels-photo-3825580.jpeg?auto=compress&cs=tinysrgb&w=800"
  },
  {
    id: 3,
    title: "Manutenção",
    description: "Serviços de reparo e manutenção em computadores e notebooks.",
    icon: "Wrench",
    image: "https://images.unsplash.com/photo-1738262039504-54d6b4a542ab?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"
  },
  {
    id: 4,
    title: "Formatação",
    description: "Backup, limpeza de disco rígido e instalação do Microsoft Windows©.",
    icon: "HardDrive",
    image: "https://images.unsplash.com/photo-1758780690553-8bc703fabca6?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"
  },
  {
    id: 5,
    title: "Instalação & Upgrade",
    description: "Instalação de componentes como SSD, HD, Memória RAM, etc.",
    icon: "Cpu",
    image: "https://images.unsplash.com/photo-1596313866728-3cff12724457?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"
  },
  {
    id: 6,
    title: "Sistema ERP de Gestão",
    description: "Sistema ERP de Gestão para Empresas, Emissor de Nota fiscal, Nota de Serviços e Nota Fiscal Consumidor Eletrônica.",
    icon: "Package",
    image: "https://images.pexels.com/photos/257904/pexels-photo-257904.jpeg?auto=compress&cs=tinysrgb&w=800"
  },
  {
    id: 7,
    title: "Redes",
    description: "Suporte em redes de internet, instalação, reparo e solução geral.",
    icon: "Network",
    image: "https://images.unsplash.com/photo-1594915440248-1e419eba6611?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"
  },
  {
    id: 8,
    title: "Consultoria",
    description: "Consultoria especializada em TI para otimização de processos.",
    icon: "Users",
    image: "https://images.unsplash.com/photo-1599453052061-5c377643e4fa?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"
  }
];

export const faqs = [
  {
    id: 1,
    question: "Sua empresa precisa de TI terceirizada?",
    answer: "Oferecemos terceirização de TI completa para empresas, com suporte técnico empresarial, gestão de TI e help desk TI especializado."
  },
  {
    id: 2,
    question: "Precisa de suporte remoto de TI?",
    answer: "Nosso help desk TI oferece suporte remoto de TI rápido e eficiente para resolver problemas sem você sair da empresa."
  },
  {
    id: 3,
    question: "Busca consultoria de TI para sua empresa?",
    answer: "Nossa consultoria de TI analisa sua infraestrutura e propõe soluções personalizadas para otimizar a gestão de TI da sua empresa."
  },
  {
    id: 4,
    question: "Sistema ERP de Gestão para Empresas?",
    answer: "Desenvolvemos sistemas ERP personalizados com emissor de Nota Fiscal, gestão financeira e controle de estoque integrado."
  },
  {
    id: 5,
    question: "Serviços de TI para empresas em Ribeirão Preto?",
    answer: "Somos uma empresa de TI em Ribeirão Preto especializada em suporte de TI para empresas, manutenção e infraestrutura."
  }
];

export const clients = [
  { id: 1, name: "Á Art Móveis", logo: "./logo-aartmoveis.png", website: "https://www.aartmoveis.com.br" },
  { id: 2, name: "Tecmoveis", logo: "./logo-tecmoveis.png", website: "https://www.tecmoveisrp.com.br" },
  { id: 3, name: "Authentica Funilaria", logo: "./logo-authentica.jpg", website: "https://www.authenticafunilaria.com.br" },
  { id: 4, name: "Precision Mecânica", logo: "./logo-precision.jpeg", website: "https://www.precisionmecanica.com.br" },
  { id: 5, name: "Atlas Automotiva", logo: "./logo-atlas.png", website: "https://atlasautomotiva.com.br/" },
  { id: 6, name: "Agily Automotiva", logo: "./logo-agily.png", website: "https://agilyautomotiva.com.br/" },
  { id: 7, name: "AATM Móveis", logo: "./logo-aatm.png", website: "https://aatmoveis.com.br/" },
  { id: 8, name: "AM Móveis", logo: "./logo-ammoveis.png", website: "https://wa.me/5516991641651?text=Ol%C3%A1%20estou%20no%20site%20Fernando%20Tech%2C%20e%20Por%20indica%C3%A7%C3%A3o%20preciso%20de%20um%20or%C3%A7amento%20para%20reforma%20de%20cadeiras%20e%20outros." },
  { id: 9, name: "Corpomedic", logo: "./logo-corpomedic-final.png", website: "https://corpomedic.com.br/" },
  { id: 10, name: "OnTime Transportes", logo: "./logo-ontime-transportes.png", website: "https://ontimetransportes.com.br/" },
  { id: 12, name: "Aroeira Locação", logo: "./logo-aroeira-locacao.jpg", website: "https://www.aroeiralocacao.com.br" },
  { id: 13, name: "A Escolar Móveis", logo: "./logo-escolar-moveis.png", website: "https://aescolarmoveis.com.br/" },
  {
    id: 14,
    name: "Abreu Machado Imóveis",
    logo: "./logo-am-imoveis.png",
    website: "https://abreumachadoimoveis.com/",
    seoTitle: "Abreu Machado Imóveis – Compra, Venda e Locação de Imóveis em Ribeirão Preto e Região",
    seoAlt: "Abreu Machado Imóveis - Imobiliária em Ribeirão Preto | Compra e Venda de Casas, Apartamentos e Terrenos",
    seoKeywords: "imóveis Ribeirão Preto, comprar imóvel, venda de imóveis, imobiliária, apartamentos, casas à venda, terrenos, Abreu Machado Imóveis"
  },
  {
    id: 15,
    name: "Danilo Contabilidade",
    logo: "./logo-danilo-contabilidade.jpeg",
    website: "https://wa.me/5516997486389?text=Ol%C3%A1%20estou%20no%20site%20Fernando%20Tech%2C%20Por%20indica%C3%A7%C3%A3o%20deles%20preciso%20de%20consultoria%20Cont%C3%A1bil.",
    seoTitle: "Danilo Contabilidade – Consultoria e Serviços Contábeis em Ribeirão Preto",
    seoAlt: "Danilo Contabilidade - Escritório de Contabilidade em Ribeirão Preto | Consultoria Contábil e Fiscal",
    seoKeywords: "contabilidade Ribeirão Preto, consultoria contábil, escritório contábil, contador, abertura de empresa, Danilo Contabilidade"
  },
  {
    id: 16,
    name: "Brunimec Brunimento",
    logo: "./logo-brunimec.jpeg",
    website: "https://wa.me/5516992875883?text=Ol%C3%A1%20Estou%20no%20site%20da%20Fernando%20Tech%20por%20indica%C3%A7%C3%A3o%20preciso%20de%20um%20Or%C3%A7amento.",
    darkLogo: true,
    seoTitle: "Brunimec Brunimento – Serviços de Brunimento Industrial em Ribeirão Preto",
    seoAlt: "Brunimec Brunimento - Serviços Industriais de Brunimento e Usinagem em Ribeirão Preto",
    seoKeywords: "brunimento, usinagem, retífica de motores, serviços industriais, mecânica industrial, Brunimec, Ribeirão Preto"
  }
];

export const aboutText = `🧠 Quem Somos

A Fernando Tech é uma empresa especializada em suporte técnico, manutenção e automação de sistemas de TI, com atuação em Ribeirão Preto e região.
Com anos de experiência no mercado, oferecemos soluções inteligentes, seguras e personalizadas para empresas e profissionais que buscam tecnologia com performance e confiança.

Nosso compromisso é garantir que a tecnologia trabalhe a favor do seu negócio, com atendimento rápido, diagnóstico preciso e resultados que realmente fazem diferença no dia a dia.

💻 Nossas Especialidades

Manutenção e suporte técnico em computadores e notebooks;

Instalação, configuração e otimização de redes cabeadas e wireless;

Consultoria em TI e automação comercial;

Implantação e suporte para sistemas fiscais e de gestão;

Soluções personalizadas para pequenas e médias empresas.

🚀 Nosso Diferencial

A Fernando Tech se destaca por unir atendimento premium com expertise técnica avançada, oferecendo suporte remoto ou presencial com agilidade e transparência.
Cada serviço é realizado com foco em qualidade, segurança e performance, sempre buscando superar as expectativas dos clientes.

🎯 Nossa Missão

Levar tecnologia eficiente e confiável para empresas e pessoas, com um atendimento humano e acessível.
Transformamos problemas técnicos em soluções simples — com clareza, profissionalismo e inovação.`;

export const contactInfo = {
  phone: "(16) 99137-8312",
  whatsapp: "+5516991378312",
  email: "contato@fernandotech.com.br",
  address: "Ribeirão Preto, SP",
  fullAddress: "Ribeirão Preto, São Paulo"
};